import { render } from "./SponsorList.vue?vue&type=template&id=a73e2694&ts=true"
import script from "./SponsorList.vue?vue&type=script&lang=ts"
export * from "./SponsorList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__